import { IInfo, IMerchant } from "@interfaces";
import { useTranslation } from "react-i18next";
import { formatDateNumber } from "src/Utils/dateUtil";
import styled from "styled-components";
import { ITypeDetail } from "../../Home";
import { IconPoint } from "../../icon/Point";

interface CustomProfile2ndLineProps {
    merchant: IMerchant;
    typeDetail: ITypeDetail;
    userInfo: IInfo | null;
    pointValue: any;
    EYPoint: any;
    expirePoint: {
        expireDate: string;
        pointExpire: number;
    };
}

export default function CustomProfile2ndLine({
    merchant,
    typeDetail,
    userInfo,
    pointValue,
    EYPoint,
    expirePoint,
}: CustomProfile2ndLineProps) {
    const themeColor = merchant.themes?.themeColor;
    const secondLine = merchant?.themes?.customizeProfile?.secondLine;
    const dateExpire = expirePoint?.expireDate;

    console.log(
        "merchant?.customizeProfile?.secondLine;",
        merchant?.themes?.customizeProfile?.secondLine
    );
    console.log("expirePoint", expirePoint);
    console.log("typeDetail", typeDetail);

    const formatDate = (dateExpire: any) => {
        const date = new Date(dateExpire);
        if (isNaN(date.getTime())) {
            return "Invalid date";
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear()).slice(-2);

        return `${day}/${month}/${year}`;
    };
    const formattedDate = formatDate(dateExpire);
    const { t } = useTranslation();

    const MemberType = ({ item }: { item: any }) => {
        return typeDetail?.typeIcon && typeDetail?.typeName ? (
            <StyledDetailMemberType
                size={item?.size}
                weight={item?.weight}
                themeColor={themeColor!}
            >
                <div className="memtype-content">
                    <span>
                        <img src={typeDetail?.typeIcon} alt="" />
                    </span>
                    {item?.isBold ? (
                        <span className="bold-text text">{typeDetail?.typeName}</span>
                    ) : (
                        <span className="text">{typeDetail?.typeName}</span>
                    )}
                </div>
            </StyledDetailMemberType>
        ) : null;
    };

    const MemberTier = ({ item }: { item: any }) => {
        return (
            <StyledMemberTier
                className={item?.size}
                color={userInfo?.memberTier?.color || themeColor || ""}
            >
                {item?.isBold ? (
                    <span className="bold-text">{userInfo?.memberTier?.tierName}</span>
                ) : (
                    <span>{userInfo?.memberTier?.tierName}</span>
                )}
            </StyledMemberTier>
        );
    };

    const TotalPointAmount = ({ item }: { item: any }) => {
        return (
            <>
                <span className="icpoint">
                    <IconPoint size={17} />
                </span>
                &nbsp;
                <span className={item?.size || "text-medium"}>
                    {item?.isBold ? (
                        <span className="bold-text">
                            {pointValue?.totalPoint !== undefined
                                ? pointValue.totalPoint.toLocaleString()
                                : "0"}{" "}
                        </span>
                    ) : (
                        <span>
                            {pointValue?.totalPoint !== undefined
                                ? pointValue.totalPoint.toLocaleString()
                                : "0"}
                        </span>
                    )}
                </span>
            </>
        );
    };

    const PointToNextTier = ({ item }: { item: any }) => {
        // console.log("pointValue.isBalance", pointValue.isBalance);

        // const maxPointThreshold = merchant?.memberShipTiers?.reduce((max: any, tier: any) => {
        //     return tier.pointThreshold > max ? tier.pointThreshold : max;
        // }, 0);

        // console.log("maxPointThreshold", maxPointThreshold);
        // console.log(
        //     "userInfo?.totalPoints >= maxPointThreshold",
        //     userInfo?.totalPoints >= maxPointThreshold
        // );

        const maxPointThreshold = pointValue?.lastTier;

        const merchantNoUseTier =
            userInfo?.BalancePointToNextTier === 0 &&
            userInfo?.allPointEarn === 0 &&
            userInfo?.pointEarnToMaintain === 0 &&
            userInfo?.maintainDate === null &&
            userInfo?.percentToAttain === 0 &&
            userInfo?.percentToMaintain === 0 &&
            userInfo?.percentToNextTierPointBalance === 0 &&
            userInfo?.pointEarnToAttain === 0 &&
            userInfo?.allSaleEarn === 0
                ? true
                : false;

        return (
            <>
                {!merchantNoUseTier && (
                    <>
                        {!maxPointThreshold ? (
                            <>
                                {userInfo?.typeTier === "point_balance" ? (
                                    <div
                                        className={[item?.size, "point-to-nexttier"]
                                            .filter(Boolean)
                                            .join(" ")}
                                    >
                                        {Number(pointValue?.pointNextTierBalance) >= 1 ? (
                                            <>
                                                {item?.isBold ? (
                                                    <span className="bold-text">
                                                        {pointValue?.pointNextTierBalance?.toLocaleString() ||
                                                            "0"}{" "}
                                                        pts to{" "}
                                                        {pointValue?.nextTierName?.toLocaleString() ||
                                                            "0"}
                                                    </span>
                                                ) : (
                                                    <span>
                                                        {pointValue?.pointNextTierBalance?.toLocaleString() ||
                                                            "0"}{" "}
                                                        pts to{" "}
                                                        {pointValue?.nextTierName?.toLocaleString() ||
                                                            "0"}
                                                    </span>
                                                )}
                                            </>
                                        ) : (
                                            <span className="bold-text">
                                                {t("page.display_profile_pointLessZero")}
                                            </span>
                                        )}
                                    </div>
                                ) : userInfo?.typeTier === "point_earn" ? (
                                    <div
                                        className={[item?.size, "point-to-nexttier"]
                                            .filter(Boolean)
                                            .join(" ")}
                                    >
                                        {Number(pointValue?.nextTierPoint) >= 1 ? (
                                            <>
                                                {item?.isBold ? (
                                                    <span className="bold-text">
                                                        {pointValue?.nextTierPoint?.toLocaleString() ||
                                                            "0"}{" "}
                                                        pts to{" "}
                                                        {pointValue?.nextTierName?.toLocaleString() ||
                                                            "0"}
                                                    </span>
                                                ) : (
                                                    <span>
                                                        {pointValue?.nextTierPoint?.toLocaleString() ||
                                                            "0"}{" "}
                                                        pts to{" "}
                                                        {pointValue?.nextTierName?.toLocaleString() ||
                                                            "0"}
                                                    </span>
                                                )}
                                            </>
                                        ) : (
                                            <span className="bold-text">
                                                {t("page.display_profile_pointLessZero")}
                                            </span>
                                        )}
                                    </div>
                                ) : userInfo?.typeTier === "sale_earn" ? (
                                    <div
                                        className={[item?.size, "point-to-nexttier"]
                                            .filter(Boolean)
                                            .join(" ")}
                                    >
                                        {Number(pointValue?.nextTierPointSaleEarn) >= 1 ? (
                                            <>
                                                {item?.isBold ? (
                                                    <span className="bold-text">
                                                        {pointValue?.nextTierPointSaleEarn?.toLocaleString() ||
                                                            "0"}{" "}
                                                        THB to{" "}
                                                        {pointValue?.nextTierName?.toLocaleString() ||
                                                            "0"}
                                                    </span>
                                                ) : (
                                                    <span>
                                                        {pointValue?.nextTierPointSaleEarn?.toLocaleString() ||
                                                            "0"}{" "}
                                                        THB to{" "}
                                                        {pointValue?.nextTierName?.toLocaleString() ||
                                                            "0"}
                                                    </span>
                                                )}
                                            </>
                                        ) : (
                                            <span className="bold-text">
                                                {t("page.display_profile_pointLessZero")}
                                            </span>
                                        )}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </>
                        ) : (
                            <>
                                <div
                                    className={[item?.size, "point-to-nexttier"]
                                        .filter(Boolean)
                                        .join(" ")}
                                >
                                    <span className="bold-text">Top-tier Member</span>
                                </div>
                            </>
                        )}
                    </>
                )}
            </>
        );
    };

    const CouponAmount = ({ item }: { item: any }) => {
        return (
            <span className={[item?.size, "coupon", "text-bottom"].filter(Boolean).join(" ")}>
                {item?.isBold ? (
                    <span className="bold-text">{userInfo?.totalCoupons} Coupons</span>
                ) : (
                    <span>{userInfo?.totalCoupons} Coupons</span>
                )}
            </span>
        );
    };

    const PointExpiryDate = ({ item }: { item: any }) => {
        return (
            <span className={item?.size || "text-bottom"}>
                {expirePoint?.pointExpire === undefined ? (
                    <span>No point expired</span>
                ) : (
                    <>
                        {item?.isBold ? (
                            <>
                                <span className="textbold">
                                    {expirePoint?.pointExpire?.toLocaleString() || "0"} pts
                                </span>{" "}
                                expire on <span className="textbold">{formattedDate}</span>
                            </>
                        ) : (
                            <>
                                <span>{expirePoint?.pointExpire?.toLocaleString() || "0"} pts</span>{" "}
                                expire on <span>{formattedDate}</span>
                            </>
                        )}
                    </>
                )}
            </span>
        );
    };

    const AccumulatedPoints = ({ item }: { item: any }) => {
        return (
            // <span className={item?.size || "text-bottom"}>
            <span className={"text-bottom"}>
                <>
                    {item?.isBold ? (
                        <>
                            <span className="textbold">
                                Accumulated Points {userInfo?.allPointEarn?.toLocaleString() || "0"}{" "}
                                pts
                            </span>{" "}
                        </>
                    ) : (
                        <>
                            <span>
                                Accumulated Points {userInfo?.allPointEarn?.toLocaleString() || "0"}{" "}
                                pts
                            </span>
                        </>
                    )}
                </>
            </span>
        );
    };

    const MemberSinceDate = ({ item }: { item: any }) => {
        return (
            <span className={item?.size || "text-bottom"}>
                {item?.isBold ? (
                    <span className="bold-text">
                        Member Since: {formatDateNumber(userInfo?.createdAt)}
                    </span>
                ) : (
                    <span>Member Since: {formatDateNumber(userInfo?.createdAt)}</span>
                )}
            </span>
        );
    };

    return (
        <>
            {secondLine?.map((item: any, index: any) => {
                console.log("item.name", item.name);
                if (item.name === "memberType") {
                    return <MemberType key={index} item={item} />;
                } else if (item.name === "memberTier") {
                    return <MemberTier key={index} item={item} />;
                } else if (
                    item.name === "totalPointAmount" &&
                    merchant?.securityConfig?.isPointDisplay === true
                ) {
                    return <TotalPointAmount key={index} item={item} />;
                } else if (
                    item.name === "pointToNextTier" &&
                    merchant?.securityConfig?.isPointDisplay === true
                ) {
                    return <PointToNextTier key={index} item={item} />;
                } else if (item.name === "couponAmount") {
                    return <CouponAmount key={index} item={item} />;
                } else if (
                    item.name === "pointExpiryDate" &&
                    merchant?.securityConfig?.isPointDisplay === true
                ) {
                    return <PointExpiryDate key={index} item={item} />;
                } else if (item.name === "memberSinceDate") {
                    return <MemberSinceDate key={index} item={item} />;
                } else if (item.name === "accumulatedPoints") {
                    return <AccumulatedPoints key={index} item={item} />;
                }
            })}
            {/* {secondLine.name === "memberType" && <MemberType />}
            {secondLine.name === "memberTier" && <MemberTier />}
            {secondLine.name === "totalPointAmount" && <TotalPointAmount />}
            {secondLine.name === "pointToNextTier" && <PointToNextTier />}
            {secondLine.name === "couponAmount" && <CouponAmount />}
            {secondLine.name === "pointExpiryDate" && <PointExpiryDate />}
            {secondLine.name === "memberSinceDate" && <MemberSinceDate />} */}
        </>
    );
}

//#region Styles

const StyledDetailMemberType = styled.div<{
    themeColor: string;
    size?: string;
    weight?: string;
}>`
    .memtype-content {
        padding: 2px 5px;
        background-color: ${(p) => p.themeColor}20;
        border-radius: 12px;
        font-weight: 500;
        font-size: 10px;
        color: ${(p) => p.themeColor};
        display: flex;
        align-items: center;
        span {
            margin-right: 5px;
            line-height: 13px;

            img {
                width: 16px;
                height: 16px;
                border-radius: 100%;
            }
        }
        span.text {
            max-width: 100px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }
`;

const StyledMemberTier = styled.div<{ color: string }>`
    span {
        color: ${(props) => props.color || "#000"};
        /* font-weight: 600; */
    }
`;

//#endregion
